// eslint-disable-next-line import/prefer-default-export
export const NUU_QUERY_DISCOUNT_CODE = 'discount_code';
export const NUU_QUERY_DC_OVERRIDE = 'dcoverride';
